import React, { Component } from 'react';
import { GraficoBarrasApiladas } from './GraficoBarrasApiladas';

const TITLE = "Reportes de Retroalimentación Estudiantil";
const APIURL = process.env.REACT_APP_API_URL;

export class GraficoParaleloArea extends Component {
  static displayName = GraficoParaleloArea.name;

  constructor(props) {
    super(props);
    this.state = { preguntas:[], frecuencias: [], alternativas: [], loading: true };
  }

  componentDidMount() {
    document.title = TITLE + " - Histórico por profesor";
    const anio = this.props.match.params["anio"];
    const termino = this.props.match.params["termino"];
    const codigo = this.props.match.params["codigo"];
    const paralelo = this.props.match.params["paralelo"];
    const identificacion = this.props.match.params["identificacion"];
    const idarea = this.props.match.params["area"];
    this.populateData(anio, termino, codigo, paralelo, identificacion, idarea);
  }

  formatter(valor) {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: '2', maximumFractionDigits: '2', signDisplay: 'never' }).format(valor)
  }

  splitwords(text, size = 40) {
    if (text.length <= size)
      return text;
    const chunks = text.split(" ");
    const parts = [];
    var aux = "";
    for (var c in chunks) {
      if (aux.length + chunks[c].length <= size) {
        aux += chunks[c] + " ";
      }
      else {
        parts.push(aux);
        aux = chunks[c] + " ";
      }
    }
    parts.push(aux);
    return parts;
  }

  renderTable(preguntas, frecuencias, alternativas) {
    //console.log(datos);
    const etiquetas = preguntas.map((p, index) => index + 1);
    const valoresFrecuencias = frecuencias.map(p => { return { ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa, frecuencia: p.frecuencia } });
    console.log(etiquetas);
    console.log(valoresFrecuencias);
    return (
      <div key={"d_" + preguntas[0].ordenArea} className="w-25 h-25" height={200}>
        <GraficoBarrasApiladas key={"gf_" + preguntas[0].ordenArea} animation={false} titulo={preguntas[0].area} labels={etiquetas} values={valoresFrecuencias} evaluados={0} />
      </div>
    );
  }

  render() {
    console.log(this.state.preguntas);
    console.log(this.state.alternativas);

    let contents = this.state.loading
      ? <p><em>Loading...</em></p>
      : this.renderTable(this.state.preguntas, this.state.frecuencias, this.state.alternativas);

    return (
      <div className="d-flex">
        {contents}
      </div>
    );
  }

  async populateData(anio, termino, codigo, paralelo, identificacion, idarea) {

    const frecuenciasResponse = await fetch(`${APIURL}/api/reportes/paralelo-frecuencias-area/${anio}/${termino}/${codigo}/${paralelo}/${identificacion}/${idarea}`);
    const dataFrecuencias = await frecuenciasResponse.json();
    console.log(dataFrecuencias);
    const preguntas = [];
    const alternativas = [];

    if (dataFrecuencias) {
      dataFrecuencias.forEach(p => {
        if (preguntas.every(f => f.ordenPregunta !== p.ordenPregunta)) {
          preguntas.push({ ordenPregunta: p.ordenPregunta, pregunta: p.pregunta });
        }

        if (alternativas.every(e => e.ordenAlternativa !== p.ordenAlternativa)) {
          alternativas.push({ ordenAlternativa: p.ordenAlternativa, alternativa: p.alternativa });
        }
      });

      this.setState({ preguntas: preguntas, frecuencias: dataFrecuencias, alternativas: alternativas, loading: false });
    }

  }
}
